import { useState, useCallback, useMemo } from 'react'
import { type FieldValue, type FieldValues, type FormConfig } from './types'

export const useFieldsValues = (
    config: FormConfig,
    onChange?: (fieldValues: FieldValues) => void
) => {
    const initialValues = useMemo<FieldValues>(() => {
        return Object.keys(config).reduce((acc, fieldName) => {
            const fieldConfig = config[fieldName]
            return Object.assign({}, acc, {
                [fieldName]: fieldConfig.value,
            })
        }, {})
    }, [config])

    const [fieldsValues, setFieldsValues] = useState<FieldValues>(initialValues)

    const setFieldValue = useCallback(
        (fieldName: string, newValue: FieldValue) => {
            setFieldsValues((fieldsValues) => {
                const newValues = Object.assign({}, fieldsValues, {
                    [fieldName]: newValue,
                })
                onChange?.(newValues)
                return newValues
            })
        },
        [onChange]
    )

    const resetFieldsValues = useCallback(() => {
        setFieldsValues(initialValues)
        onChange?.(initialValues)
    }, [initialValues, onChange])

    return { initialValues, fieldsValues, setFieldValue, resetFieldsValues }
}
